// navigation tab details
export * from './NavigationTab';
export { default as Dashboard } from './dashboard/Dashboard';
export { default as Navbar } from './Navbar/Navbar';
export { default as Sidebar } from './Sidebar/Sidebar';
export { default as getMenu } from './Sidebar/menu';



// WEBPACK FOOTER //
// ./src/components/navigation/index.js